/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { IDeviceConfigInitialState } from "./types";

export let initialState: IDeviceConfigInitialState = {
  lanDeviceList: [],
  zoneDeviceList: [],
  isAddNewLanDevice: false,
  isAddNewIPInterface: false,
  isAddNewZoneDevice: false,
  isAddNewRfFeed: false,
  lanDeviceIndexes: [],
  rfFeedIndexes: [],
  zoneCellIndexes: [],
  rfFeedList: [],
  selectedLanDevice: {
    enable: "true",
    index: "",
    name: "",
    maxBitRate: "1000",
    duplex: "Full",
    ipInterfaces: [],
  },
  selectedIPInterface: {
    description: "",
    dhcpServerEnable: "",
    egressQosGroup: "",
    forwardingGroupIndex: "",
    index: "",
    ipInterfaceIpAddress: "",
    ipInterfaceSubnetMask: "",
    operState: "Unknown",
    vlanId: "",
    enable: "false",
    // stats: { bytesReceived: "", bytesSent: "", index: "", packetsReceived: "", packetsSent: "" },
  },
  selectedRfFeed: {
    index: "",
    type: "",
    dlarfcn: "",
    ularfcn: "",
    dlBandwidth: "",
    ulBandwidth: "",
    //dlAttenuation: "",
  },
  selectedZoneDevice: {
    index: "",
    cellList: [],
    scSpacingCommon: "",
    description: "",
    nrcell: 0,
    zoneType: "SONConfigAndScanZone",
    priority: "",
    barringforemergency: false,
    eARFCNUL: "",
    ulBandwidth: "",
    eARFCNDL: "",
    dlBandwidth: "",
  },
  configCounts: {},
  configStatusData: [],
  isAddNewLteX2Connection: false,
  lteX2ConnectionIndexes: [],
  lteX2ConnectionList: [],
  selectedLteX2Connection: {
    index: "",
    enable: "false",
    name: "",
    address: "0.0.0.0",
    connectionState: "",
    localAddress: "",
    plmnId: "0",
    port: "36422",
    tac: "0",
    type: "HeNB",
    eNodeBID: "0",
    gNodeBID: "0",
    remoteAddress: "",
    connectionId: "",
    isENDCX2: "false",
  },
  isAddNewNgX2Connection: false,
  ngX2ConnectionIndexes: [],
  ngX2ConnectionList: [],
  radioUnitIndexes: [],
  selectedNgX2Connection: {
    index: "",
    enable: "false",
    name: "",
    address: "0.0.0.0",
    connectionState: "",
    localAddress: "",
    plmnId: "0",
    port: "36422",
    eNodeBID: "0",
    remoteAddress: "",
    connectionId: "",
  },
  isZoneAdded : false
};
